import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { request } from "../../commons/utils";
import { USER_ACTIVITIES_BY_ID } from "../../commons/constants";
import moment from "moment";
import "moment/locale/tr";

moment.locale("tr");

export const ACTIVITY_ENUMS = {
  LOGIN: "Uygulama Giriş",
  WEB_LOGIN: "Web Giriş",
  LOGOUT: "Çıkış Yapıldı",
  BUY_PACKAGE: "Paket Satın Alındı",
  CHANGE_PASSWORD: "Şifre Değiştirildi",
  REGISTER: "Kayıt Olundu",
  REGISTER_BULK: "Toplu Kayıt",
  INIT: "INIT",
  USER_UPDATE: "Kullanıcı Bilgisini Güncelledi",
  GET_WORD: "En Son Kelime Görüntüleme",
  PROVIDER_LOGIN: "Google/Apple ile Giriş",
};

const UserActivitiesModal = ({ open, onClose, user }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && user?.id) {
      fetchActivities();
    } else {
      setActivities([]);
    }
  }, [open, user]);

  const fetchActivities = async () => {
    setLoading(true);
    const res = await request(
      `${USER_ACTIVITIES_BY_ID}/${user.id}/activities`,
      "GET",
      false,
      true,
    );
    if (res && res.status && res.data) {
      setActivities(res.data);
    }
    setLoading(false);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{ style: { backgroundColor: "#1E1E2D", color: "#fff" } }}
    >
      <DialogTitle style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div>
            <h3 style={{ margin: 0, color: "#fff" }}>Kullanıcı Aktiviteleri</h3>
            <p
              style={{
                margin: 0,
                marginTop: 4,
                fontSize: "0.9rem",
                color: "rgba(255,255,255,0.6)",
              }}
            >
              {user?.name} - {user?.mail}
            </p>
          </div>
          <IconButton onClick={onClose} style={{ color: "#fff" }}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ padding: "20px" }}>
        {loading ? (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              color: "rgba(255,255,255,0.6)",
            }}
          >
            Yükleniyor...
          </div>
        ) : activities.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              color: "rgba(255,255,255,0.6)",
            }}
          >
            Aktivite bulunamadı.
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            {activities.map((act, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "rgba(255,255,255,0.05)",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  borderLeft: "4px solid #00F2FF",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <strong style={{ color: "#00F2FF", fontSize: "1.05rem" }}>
                    {ACTIVITY_ENUMS[act.activity_id] || act.activity_id}
                  </strong>
                  <span
                    style={{
                      fontSize: "0.85rem",
                      color: "rgba(255,255,255,0.5)",
                    }}
                  >
                    {moment(act.createdAt).format("DD.MM.YYYY HH:mm")}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default UserActivitiesModal;
